import { useQuery } from "@tanstack/react-query";
import { attendanceApi } from "@/lib/api/attendance";

/** The roll read both homes mount the register from; a save writes its answer here. */
export const sessionRollQueryKey = (sessionId: string) => ["attendance", "session", sessionId] as const;

/** One session's roll, as the server holds it. Shared by both homes so a submit in one refreshes the other. */
export function useSessionRoll(sessionId: string, enabled = true) {
  return useQuery({
    queryKey: sessionRollQueryKey(sessionId),
    queryFn: () => attendanceApi.getSessionAttendance(sessionId),
    enabled: enabled && !!sessionId,
  });
}
